import {router} from '@netx/core-router';

export const routeToCategory = (id: number) =>
	router.navigate(`category/${id}`, true);

export default routeToCategory;
